import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api';

const EditPurchaseReturn = () => {
    const { id } = useParams(); // Get the purchase return ID from the URL
    const navigate = useNavigate();

    // State for holding purchase return data
    const [formData, setFormData] = useState({
        pack_unit: '',
        pack_qty: '',
        unit: '',
        quantity: '',
        rate: '',
        amount: '',
        discount: '',
        taxcode: '',
        taxrate: '',
        taxable: '',
        taxamount: '',
        cess_rate: '',
        cess_amount: '',
        mrp: '',
        net_rate: '',
        remarks: '',
        item_barcode: '',
        posting_gl: '',
        pi_vno: '',
        pi_ref_no: '',
        pi_ref_date: '',
        pi_vdate: '',
        bd_batch_no: '',
        bd_mfg_date: '',
        bd_exp_date: '',
        bd_sale_rate: '',
        item_balance: '',
        barcode: '',
        line_level_barcode: '',
        lgst: '',
        cgst: '',
        sgst: '',
        hsn_code: '',
        brand: ''
    });

    // Fetch purchase return details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}purchasereturns/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data) {
                    setFormData(data);
                }
            })
            .catch(error => console.error('Error fetching purchase return details:', error));
    }, [id]);

    // Handle form input changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        fetch(`${BASE_URL}purchasereturns/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    alert("Purchase return updated successfully!");
                    navigate('/PurchaseReturnsList'); // Navigate to the purchase returns list page
                } else {
                    alert("Error updating purchase return. Please try again.");
                }
            })
            .catch(error => console.error('Error updating purchase return:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Purchase Return</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {Object.keys(formData).map((key) => (
                                        <div className="mb-3" key={key}>
                                            <label htmlFor={key} className="form-label">
                                                {key.replace(/_/g, ' ').toUpperCase()}
                                            </label>
                                            <input
                                                type="text"
                                                id={key}
                                                name={key}
                                                className="form-control"
                                                value={formData[key]}
                                                onChange={handleChange}
                                                placeholder={`Enter ${key}`}
                                                required
                                            />
                                        </div>
                                    ))}
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Purchase Return</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPurchaseReturn;
